import { Category, FilterOption, BooleanOptions } from "@interface";

export const residentialUnitConditions: FilterOption[] = [
    { label: 'At Least', value: 'atLeast' },
    { label: 'Between', value: 'between' },
    { label: 'At Most', value: 'atMost' },
    { label: 'Exactly', value: 'exactly' },
];

export const generalConditionOptions: FilterOption[] = [
    { label: 'Exactly', value: 'exactly' },
    { label: 'At Least', value: 'atLeast' },
    { label: 'At Most', value: 'atMost' },
    { label: 'Greater Than', value: 'greaterThan' },
    { label: 'Less Than', value: 'lessThan' },
];

export const timeConditionOptions: FilterOption[] = [
    { label: 'Since', value: 'since' },
    { label: 'Before', value: 'before' },
    { label: 'Between', value: 'between' },
];

export const dateConditionOptions: FilterOption[] = [
    { label: 'After', value: 'after' },
    { label: 'Before', value: 'before' },
    { label: 'Between', value: 'between' },
];

export const booleanOptions: BooleanOptions[] = [
    { label: 'Yes', value: 1 },
    { label: 'No', value: 0 },
];

export const programsList : string[] = [
    '420-c Tax Incentive Program',
    '421a Affordable',
    '421-a Tax Incentive Program',
    '421-g Tax Incentive Program',
    'Article 8A/HRP',
    'Inclusionary Housing',
    'J-51 Tax Incentive',
    'LAMP - HDC',
    'LIHTC 4%',
    'LIHTC 9%',
    'LIHTC Year 15',
    'Loan Management Set-Aside',
    'Mitchell-Lama',
    'Multi-Family Program',
    'Neighborhood Entrepreneur Program',
    'Neighborhood Redevelopment Program',
    'Other HPD Programs',
    'Other HUD Financing',
    'Other HUD Project-Based Rental Assistance',
    'Participation Loan Program',
    'Project-Based Section 8',
    'Project Rental Assistance Contract /202',
    'Section 202/8',
    'Section 221d(3) and Section 221d(4) Mortgage Insurance',
    'Section 223(f)',
    'Section 8 - RAD',
    'TPT',
];

export const baseFilters = [
    { label: 'Residential Units', value: 'residentialUnits', isBoolean: false },
    { label: 'Has SRO units?', value: 'sroUnits', isBoolean: true },
];

export const filterOptionsByCategory: Record<Category, FilterOption[]> = {
    all: [
        ...baseFilters,
        { label: 'Is 7A program?', value: '7AProgram', isBoolean: true },
    ],
    rent: [
        {
            label: 'Change in # of Stabilized Units',
            value: 'rentStabilized',
            hasTimeCondition: true,
        },
        ...baseFilters,
        { label: 'Is 7A program?', value: '7AProgram', isBoolean: true },
    ],
    subsidized: [
        { label: 'Programs', value: 'programs', isMultiSelect: true },
        { label: 'Expiration', value: 'expiration', hasDateCondition: true },
        ...baseFilters,
        { label: 'Is 7A program?', value: '7AProgram', isBoolean: true },
    ],
    small: [...baseFilters],
    market: [...baseFilters],
    public: [...baseFilters],
};

export const filterOptions: FilterOption[] = [
    { label: 'HPD Violations', value: 'hpdViolations' },
    { label: 'DOB Violations', value: 'dobViolations' },
    { label: 'ECB Violations', value: 'ecbViolations' },
    { label: 'HPD Complaints & Problems', value: 'hpdComplaints' },
    { label: 'DOB Complaints', value: 'dobComplaints' },
    { label: 'DOB Permit Applications', value: 'dobPermitApplications' },
    { label: 'DOB Permits Issued', value: 'dobPermitsIssued' },
    { label: 'Marshal Evictions', value: 'marshalEvictions' },
    { label: 'Litigations Against Landlord', value: 'litigations' },
    // { label: 'Foreclosure Filings', value: 'foreclosureFilings' },
    { label: 'Sales', value: 'sales' },
    { label: 'Tax Lien', value: 'taxLien' },
    { label: 'Certificate of No Harassment', value: 'noHarassment' },
    { label: 'Alternative Enforcement Program', value: 'alternativeEnforcement' },
];

export const timeOptions: FilterOption[] = [
    { label: 'Since', value: 'since' },
    { label: 'Before', value: 'before' },
    { label: 'Between', value: 'between' },
];

export const classOptions: FilterOption[] = [
    { label: 'Class A', value: 'A' },
    { label: 'Class B', value: 'B' },
    { label: 'Class C', value: 'C' },
];

export const statusOptions: FilterOption[] = [
    { label: 'Opened', value: 'open' },
    { label: 'Closed', value: 'close' },
    { label: 'Active', value: 'active' },
    { label: 'Resolved', value: 'resolve' },
    { label: 'Discharged', value: 'discharge' },
];

export const enforcementStatusOptions: FilterOption[] = [
    { label: 'Active', value: 'active' },
    { label: 'Discharged', value: 'discharge' },
];

export const yesNoOptions: FilterOption[] = [
    { label: 'Yes', value: 'yes' },
    { label: 'No', value: 'no' },
];

export const typeOptions: FilterOption[] = [
    { label: 'A1', value: 'a1' },
    { label: 'A2', value: 'a2' },
    { label: 'A3', value: 'a3' },
    { label: 'NB', value: 'NB' },
    { label: 'DM', value: 'DM' },
];

export const saleTypeOptions: FilterOption[] = [
    { label: 'Commercial', value: 'COMMERCIAL' },
    { label: 'Residential', value: 'RESIDENTIAL' },
];

// Maps filter types to available option types
export const filterOptionMap: Record<string, string[]> = {
    hpdViolations: ['class', 'status'],
    dobViolations: ['status'],
    ecbViolations: ['status'],
    hpdComplaints: ['status'],
    dobComplaints: ['status'],
    dobPermitApplications: ['type'],
    dobPermitsIssued: ['type'],
    marshalEvictions: ['type'],
    litigations: [],
    sales: ['salePrice', 'saleAmount'],
    alternativeEnforcement: ['status']
};

// Define filter types that use Yes/No dropdown instead of count and condition
export const yesNoFilterTypes: string[] = ['taxLien', 'noHarassment', 'alternativeEnforcement'];
